import { createContext, useContext } from 'react';

export const AppContext = createContext({
  userId: '',
});

export const useAppContext = () => useContext(AppContext);
